'use strict';


export default {
    url: '/',
    alias: 'file',
    headers: {},
    queue: [],
    progress: 0,
    autoUpload: false,
    removeAfterUpload: false,
    method: 'POST',
    filters: [],
    formData: [],
    queueLimit: Number.MAX_VALUE,
    withCredentials: false
};


/** WEBPACK FOOTER **
 ** c:/OpenServer/domains/angular-file-upload.my/src/values/options.js
 **/